// Mock data for Knight Credit Consultants website

export const companyInfo = {
  name: "Knight Credit Consultants",
  tagline: "Your Knight in shining armor to good credit",
  tollFree: "1 (888) 96-KNIGHT",
  phones: ["1 (513) 278-3818"],
  fax: "1 (513) 399-4989",
  email: "damon.knight@knightcreditconsultants.com",
  address: "Cincinnati, OH",
  socials: {
    instagram: "https://instagram.com/knightcredit06",
    instagramHandle: "@knightcredit06",
    threads: "#",
    facebook: "#",
    twitter: "#",
    tiktok: "#",
    youtube: "#"
  }
};

// Success stories with verified before/after scores
export const successStories = [
  { initials: "K.W.", name: "Keisha W.", state: "Ohio", before: 351, after: 748, months: 8, quote: "Started with a bankruptcy on my report. 8 months and they got me to 748. My mortgage lender couldn't believe it." },
  { initials: "F.T.", name: "Felix T.", state: "Ohio", before: 461, after: 697, months: 2, quote: "Went from 461 to 697 in 2 months! I wasn't expecting results that fast. They actually know what they're doing." },
  { initials: "D.A.", name: "Devon A.", state: "Kentucky", before: 451, after: 722, months: 4, quote: "Multiple deletions in 4 months. They handle everything and keep you in the loop. Already referred 3 friends." },
  { initials: "T.C.", name: "Tasha C.", state: "Indiana", before: 365, after: 719, months: 6, quote: "My credit was a mess at 365 with student loans in default. Now I'm at 719 and got approved for my first apartment." },
  { initials: "M.J.", name: "Marcus J.", state: "Georgia", before: 412, after: 689, months: 4, quote: "Had collections and late payments dragging me down for years. They cleaned up my report and got me a car at a good rate." },
  { initials: "P.L.", name: "Pedro L.", state: "Texas", before: 423, after: 718, months: 4, quote: "Stuck in the low 400s for years. 4 months later I'm at 718 and just got approved for my first real credit card." },
  { initials: "J.R.", name: "James R.", state: "North Carolina", before: 502, after: 741, months: 2, quote: "Only took 2 months to go from 502 to 741. Super responsive every time I had a question. Best investment I've made." },
  { initials: "D.M.", name: "Danielle M.", state: "Michigan", before: 378, after: 762, months: 7, quote: "I was in the 300s with repos and collections everywhere. 7 months later I'm at 762 and just bought my first house!" },
  { initials: "A.B.", name: "Aisha B.", state: "Maryland", before: 412, after: 736, months: 5, quote: "Three medical collections deleted by month two. By month five I had a 736 and qualified for a refi that saved us $340/mo." },
  { initials: "R.S.", name: "Ramon S.", state: "Florida", before: 489, after: 705, months: 3, quote: "Identity theft destroyed my credit. Damon's team had every fraudulent account removed in 3 months. I got my life back." },
  { initials: "L.K.", name: "Latoya K.", state: "Illinois", before: 358, after: 728, months: 6, quote: "I cried when I saw 728 on my report. After two repos I never thought it was possible. Worth every single dollar." },
  { initials: "C.O.", name: "Christopher O.", state: "Tennessee", before: 445, after: 711, months: 5, quote: "Bought my first home this spring. Started this journey with no clue what to do. Knight made it simple and they kept me updated weekly." }
];

// Verified credit-report-style cards (mocked report visuals)
export const verifiedReports = [
  { points: 375, deletions: "4 deletions", bureau: "TransUnion", duration: "5 months" },
  { points: 478, deletions: "24 deletions", bureau: "All 3 Bureaus", duration: "7 months" },
  { points: 279, deletions: "10 positive updates", bureau: "Experian", duration: "3 months" },
  { points: 631, deletions: "8 deletions", bureau: "Equifax", duration: "9 months" },
  { points: 241, deletions: "15 deletions", bureau: "All 3 Bureaus", duration: "6 months" },
  { points: 545, deletions: "18 deletions", bureau: "All 3 Bureaus", duration: "8 months" },
  { points: 276, deletions: "15 deletions", bureau: "TransUnion", duration: "4 months" },
  { points: 349, deletions: "26 deletions", bureau: "All 3 Bureaus", duration: "6 months" }
];

export const whatDrivesUs = [
  { icon: "Shield", title: "Integrity", text: "We always do what's right for our clients, even when it's not the easiest path." },
  { icon: "Eye", title: "Transparency", text: "Clear communication, honest timelines, and realistic expectations \u2014 every step of the way." },
  { icon: "Award", title: "Excellence", text: "We continuously improve our dispute methods to deliver the best possible results." },
  { icon: "GraduationCap", title: "Education", text: "We empower clients with the knowledge to maintain strong credit for life." }
];

export const addOns = [
  {
    name: "Inquiry Removal",
    price: 300,
    badge: "Popular",
    description: "Hard inquiries dragging your score down? We dispute unauthorized and inaccurate inquiries across all 3 bureaus.",
    features: [
      "Disputes with all 3 credit bureaus",
      "Flat fee \u2014 covers all eligible inquiries",
      "Average timeline: 1\u20133 months",
      "Priority processing included",
      "No minimum number of inquiries required"
    ]
  },
  {
    name: "ChexSystems Removal",
    price: 300,
    badge: null,
    description: "Can't open a bank account? We dispute inaccurate accounts and inquiries on your ChexSystems report to restore banking eligibility.",
    features: [
      "Complete ChexSystems report analysis",
      "Dispute inaccurate accounts & inquiries",
      "Restore banking eligibility",
      "Priority processing included",
      "Minimal documentation required"
    ]
  },
  {
    name: "Debt Validation Letters",
    price: 300,
    badge: null,
    description: "Force debt collectors to prove the debt is legally yours under the FDCPA. $300 covers up to 3 accounts.",
    features: [
      "$300 per 3 accounts",
      "FDCPA-compliant letter drafts",
      "Sent via USPS Certified Mail",
      "Collector response tracking",
      "Escalation if collector ignores"
    ]
  }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "How It Works", path: "/how-it-works" },
  { name: "Pricing", path: "/pricing" },
  { name: "Testimonials", path: "/testimonials" },
  { name: "Blog", path: "/blog" },
  { name: "Contact", path: "/contact" }
];

export const services = [
  {
    id: "01",
    title: "Credit Repair",
    short: "Remove negative items to boost your score.",
    description: "Take the first step toward financial freedom. Our Credit Repair services target negative items on your credit report, improving your score and helping you rebuild a solid credit foundation.",
    icon: "ShieldCheck"
  },
  {
    id: "02",
    title: "Credit Education",
    short: "Learn to manage your credit.",
    description: "Understanding credit is crucial to making informed financial decisions. Our Credit Education services equip you with the knowledge to manage and maintain a strong credit profile for years to come.",
    icon: "BookOpen"
  },
  {
    id: "03",
    title: "Credit Monitoring",
    short: "Get alerts on changes to your credit.",
    description: "Stay in control of your credit with our monitoring services. We provide real-time updates and alerts to keep you informed of any changes, so you're always a step ahead.",
    icon: "Activity"
  },
  {
    id: "04",
    title: "Credit Action Plan",
    short: "Follow a tailored credit improvement strategy.",
    description: "Every journey to credit recovery is unique. Our Credit Action Plan gives you a clear, step-by-step strategy tailored to your specific credit goals, helping you achieve financial stability.",
    icon: "Target"
  }
];

export const steps = [
  "We start with an initial free consultation.",
  "You will sign up for a monthly credit-monitoring service with SmartCredit.",
  "We will enter your information into our system.",
  "Together, we will review your credit report for accuracy of personal information and inaccurate items.",
  "We will guide you to take the first steps of managing your financial future. We provide a roadmap of what and what not to do while undergoing the credit repair process.",
  "Before any payments are accepted, we will begin the dispute process.",
  "On a monthly basis, we will set up a meeting with you and review the progress and projections of your future scores.",
  "We continue this process until you have reached your target credit score.",
  "You can contact us anytime with questions or concerns.",
  "24/7 access to your own private, secure portal."
];

export const pricingPlans = [
  {
    name: "INDIVIDUAL",
    price: 150,
    setupFee: 200,
    priceLabel: "/mo",
    setupLabel: "$200 First Work Fee",
    biweekly: true,
    description: "",
    popular: true,
    features: [
      "Three-bureau reports and scores",
      "Unlimited Credit Bureau Disputes",
      "One-on-one consultations",
      "Unlimited Inquiry dispute letters",
      "Every 60 days credit review",
      "Notarized POA letters when needed",
      "In-depth credit analysis",
      "Debt Validation Letters",
      "Cease and Desist letters",
      "Personal Information Correction Letters",
      "Mobile App for 24/7 access",
      "Biweekly payment plan available",
      "Cancel at anytime"
    ],
    documents: "Copies of your driver's license, social security card, and a copy of a utility bill or any bill verifying your address."
  },
  {
    name: "COUPLES",
    price: 250,
    setupFee: 300,
    priceLabel: "/mo",
    setupLabel: "$300 First Work Fee",
    biweekly: true,
    description: "",
    popular: false,
    features: [
      "Three-bureau reports and scores (both partners)",
      "Unlimited Credit Bureau Disputes",
      "One-on-one consultations",
      "Unlimited Inquiry dispute letters",
      "Every 60 days credit review",
      "Notarized POA letters when needed",
      "In-depth credit analysis",
      "Debt Validation Letters",
      "Cease and Desist letters",
      "Personal Information Correction Letters",
      "Mobile App for 24/7 access",
      "Biweekly payment plan available",
      "Cancel at anytime"
    ],
    documents: "Both partners: driver's license, social security card, and a utility bill (or similar) verifying address."
  },
  {
    name: "DIY DISPUTE LETTERS",
    price: 150,
    setupFee: 0,
    priceLabel: "one-time",
    setupLabel: "One-time purchase",
    biweekly: false,
    description: "Perfect for self-starters who want to handle disputes on their own timeline. Get the same attorney-reviewed letter library our team uses \u2014 delivered instantly to your inbox after purchase.",
    popular: false,
    oneTime: 150,
    features: [
      "100 Attorney reviewed letters",
      "Covers FCRA, FDCPA & CROA citations",
      "Round 1, 2, 3 escalation templates included",
      "Common dispute reasons pre-written",
      "Step-by-step mailing instructions",
      "Print, sign, and send on your own timeline",
      "Editable Word + PDF formats",
      "Instant digital delivery"
    ],
    documents: "No documents required \u2014 digital delivery to your email after purchase."
  }
];

export const pricingFaqs = [
  {
    q: "What's the difference between the three plans?",
    a: "Credit Monitoring is a monitoring-only plan with no dispute work. Individual includes full dispute work for one person. Couples covers two profiles with the same dispute work + bonuses for shared households."
  },
  {
    q: "What is the First Work Fee?",
    a: "It's the one-time onboarding charge that covers initial credit audit, dispute strategy, and first-round letter drafting. It's charged 5 days after we complete your credit report audit."
  },
  {
    q: "Are biweekly payments really available?",
    a: "Yes \u2014 on the Individual plan, you can split your $150 monthly fee into two $75 biweekly payments to align with your paychecks. Just let us know during onboarding."
  },
  {
    q: "Do I need to commit long-term?",
    a: "No. There are no long-term contracts. You can cancel at any time \u2014 and most clients see meaningful progress within 90\u2013180 days."
  },
  {
    q: "Are there any hidden fees?",
    a: "None. The First Work Fee and the monthly subscription are the only base charges. Add-on services (Inquiry Removal, ChexSystems Removal, Debt Validation Letters) are optional and clearly priced."
  },
  {
    q: "Can I upgrade or downgrade later?",
    a: "Absolutely. You can move from Credit Monitoring up to Individual or Couples (or vice versa) at any time. Changes take effect on your next billing cycle."
  },
  {
    q: "Will disputing hurt my credit score?",
    a: "No. Filing a dispute does not lower your score. In most cases, removing inaccurate negative items increases your score over time."
  },
  {
    q: "Is credit repair legal?",
    a: "Yes. The Fair Credit Reporting Act (FCRA) gives every consumer the right to dispute inaccurate, unverifiable, or outdated items on their credit report."
  }
];

export const testimonials = [
  {
    name: "Mary Y",
    location: "OH",
    quote: "Thanks to Damon I was finally able to get my credit score up so I can afford my dream car!",
    rating: 5,
    scoreBefore: 540,
    scoreAfter: 720
  },
  {
    name: "Gary J",
    location: "NY",
    quote: "The process took less time than I expected. Now I'm almost at a 700 credit score!",
    rating: 5,
    scoreBefore: 560,
    scoreAfter: 695
  },
  {
    name: "Jason L",
    location: "MI",
    quote: "I love the mobile app. I am able to check my file 24/7 from my phone! Most places don't have an app.",
    rating: 5,
    scoreBefore: 580,
    scoreAfter: 740
  },
  {
    name: "Trisha M",
    location: "NY",
    quote: "Damon made me feel comfortable talking about my financial challenges.",
    rating: 5,
    scoreBefore: 520,
    scoreAfter: 685
  },
  {
    name: "Tonya M",
    location: "OH",
    quote: "Damon was very professional and patient with me. Now my son has his own yard to play in!",
    rating: 5,
    scoreBefore: 600,
    scoreAfter: 760
  },
  {
    name: "Andre B",
    location: "KY",
    quote: "Knight Credit got two collections removed in the first 45 days. Customer service was top-tier the whole way.",
    rating: 5,
    scoreBefore: 555,
    scoreAfter: 712
  },
  {
    name: "Lashonda P",
    location: "IN",
    quote: "Closed on my first home this year thanks to Damon and the team. They walked me through every dispute step.",
    rating: 5,
    scoreBefore: 510,
    scoreAfter: 705
  },
  {
    name: "Marcus K",
    location: "OH",
    quote: "I came in skeptical and left a believer. Honest pricing, clear timeline, and real results in 3 months.",
    rating: 5,
    scoreBefore: 590,
    scoreAfter: 735
  },
  {
    name: "Vanessa R",
    location: "TN",
    quote: "Damon and the Knight team walked me through every step. Two charge-offs gone, score up 158 points in 6 months \u2014 worth every penny.",
    rating: 5,
    scoreBefore: 545,
    scoreAfter: 703
  }
];

export const stats = [
  { value: 500, suffix: "+", label: "Happy Clients" },
  { value: 180, suffix: "+", label: "Average Score Increase" },
  { value: 98, suffix: "%", label: "Success Rate" },
  { value: 24, suffix: "/7", label: "Portal Access" }
];

export const faqs = [
  {
    q: "How long does the credit repair process take?",
    a: "Most clients see meaningful results within 90\u2013180 days. Complex cases can take longer, but our team keeps you updated every 60 days with a full review."
  },
  {
    q: "Is credit repair legal?",
    a: "Yes. The Fair Credit Reporting Act (FCRA) gives every consumer the right to dispute inaccurate, unverifiable, or outdated items on their credit report."
  },
  {
    q: "Can you guarantee results?",
    a: "By law, no credit repair company can guarantee specific score increases. We can guarantee transparent communication, professional dispute work, and our cancel-anytime policy."
  },
  {
    q: "What items can be removed?",
    a: "Common removals include late payments, collections, charge-offs, repossessions, bankruptcies, hard inquiries, and inaccurate personal information."
  },
  {
    q: "Do I need to cancel my credit cards?",
    a: "No. In most cases, keeping older accounts open helps your length of history and utilization. We'll guide you on what to keep and what to address."
  },
  {
    q: "Will this affect my current credit score negatively?",
    a: "Disputing items does not lower your score. In most cases, removing negative items increases your score over time."
  }
];

export const features = [
  { icon: "ShieldCheck", title: "Transparent Process", text: "Honest, ethical credit repair with full visibility every step of the way." },
  { icon: "Sparkles", title: "Personalized Plans", text: "Custom action plans designed around your unique credit profile and goals." },
  { icon: "Smartphone", title: "24/7 Mobile Portal", text: "Track disputes and progress anytime from our secure mobile app." },
  { icon: "Award", title: "Proven Results", text: "Hundreds of clients have improved their scores with our strategies." }
];
